import { IAdminInsightsResult } from '../types/IAdminInsightsResult';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class AdminInsightsGetProjectIdRequest
    extends Request<{},IAdminInsightsResult> {

    constructor() {
        super('getAdminInsightsProjectId', {});
    }
}
